import script from "./QuickpaySettingsRecommendation.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickpaySettingsRecommendation.vue?vue&type=script&setup=true&lang=js"

import "./QuickpaySettingsRecommendation.vue?vue&type=style&index=0&id=20c8446a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20c8446a"]])

export default __exports__